import { Navigate, Route, Routes } from "react-router-dom"

import RootLayout from "./components/layout/RootLayout"
import AppProvider from "./shared/provider/AppProvider"
import Login from "./pages/auth/Login"
import Main from "./pages/main/Main"
import NewsList from "./pages/main/components/news/NewsList"
import NewsDetail from "./pages/main/components/news/NewsDetail"
import GalleryList from "./pages/main/components/gallery/GalleryList"
import VideoList from "./pages/main/components/video/VideoList"
import GalleryDetail from "./pages/main/components/gallery/GalleryDetail"
import VideoDetail from "./pages/main/components/video/VideoDetail"
import { STAR_URL_NAME } from "./shared/constants/star"

function App() {
  return (
    <AppProvider>
      <Routes>
        <Route
          path="/"
          element={<Navigate to={`/${STAR_URL_NAME}`} replace />}
        />

        <Route path={`/:starUrlName`} element={<RootLayout />}>
          <Route index element={<Main />} />
          <Route path="news" element={<NewsList />} />
          <Route path="news/:id" element={<NewsDetail />} />

          <Route path="gallery" element={<GalleryList />} />
          <Route path="gallery/:id" element={<GalleryDetail />} />

          <Route path="video" element={<VideoList />} />
          <Route path="video/:id" element={<VideoDetail />} />

          <Route path="*" element={<Navigate to="" replace />} />
        </Route>

        <Route path="login" element={<Login />} />
      </Routes>
    </AppProvider>
  )
}

export default App
